import React from 'react'
import {Modal, Button} from 'react-bootstrap'
import {formatUTCToUserDate} from '../../helper/helperFunction'

interface DeviceDetailsModalProps {
  show: boolean
  onHide: () => void
  device: any
}

const DeviceDetailsModal: React.FC<DeviceDetailsModalProps> = ({show, onHide, device}) => {
  if (!device) return null

  const formatStatus = (assigned: boolean) => {
    if (assigned) return 'Assigned'
    return 'Available'
  }

  const formatOwnership = (device: any) => {
    const type = device.ownership_type || 'purchased'
    return type.charAt(0).toUpperCase() + type.slice(1)
  }

  return (
    <Modal show={show} onHide={onHide} centered size='lg'>
      <Modal.Header closeButton>
        <Modal.Title>Device Information</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='row g-3'>
          <div className='col-md-6'>
            <div className='card border-0 bg-light'>
              <div className='card-body'>
                <h6 className='text-primary mb-3'>Device Details</h6>
                <div className='mb-2'>
                  <strong>Device Name:</strong>
                  <div className='text-muted'>{device.Device?.name ?? 'N/A'}</div>
                </div>
                <div className='mb-2'>
                  <strong>IMEI:</strong>
                  <div className='text-muted'>{device.Device?.imei ?? 'N/A'}</div>
                </div>
                <div className='mb-2'>
                  <strong>Model Number:</strong>
                  <div className='text-muted'>{device.Device?.model_no ?? 'N/A'}</div>
                </div>
                <div className='mb-2'>
                  <strong>Ownership:</strong>{' '}
                  <span className={`badge ${
                    device.ownership_type === 'rental'
                      ? 'bg-success'
                      : device.ownership_type === 'loaned'
                      ? 'bg-warning'
                      : 'bg-info'
                  }`}>
                    {formatOwnership(device)}
                  </span>
                </div>
                <div className='mb-2'>
                  <strong>Status:</strong>
                  <span
                    className={`badge ${
                      device.Device?.AllocatedDevice?.length > 0 ? 'bg-success' : 'bg-secondary'
                    }`}
                  >
                    {formatStatus(device.Device?.AllocatedDevice?.length > 0)}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className='col-md-6'>
            <div className='card border-0 bg-light'>
              <div className='card-body'>
                <h6 className='text-primary mb-3'>Assignment Details</h6>
                <div className='mb-2'>
                  <strong>Assigned To Patient:</strong>
                  <div className='text-muted'>
                    {device.Device?.AllocatedDevice?.[0]?.Patient?.full_name || 'Not assigned'}
                  </div>
                </div>
                <div className='mb-2'>
                  <strong>Patient Status:</strong>
                  <div className='text-muted'>
                    {device.Device?.AllocatedDevice?.[0]?.Patient?.status === 1
                      ? 'Active'
                      : device.Device?.AllocatedDevice?.[0]?.Patient?.status === 0
                      ? 'Inactive'
                      : 'N/A'}
                  </div>
                </div>
                <div className='mb-2'>
                  <strong>Assigned At:</strong>
                  <div className='text-muted'>
                    {device.Device?.AllocatedDevice?.[0]?.devices_assigned_date
                      ? formatUTCToUserDate(device.Device.AllocatedDevice[0].devices_assigned_date)
                      : 'N/A'}
                  </div>
                </div>
                <div className='mb-2'>
                  <strong>Allocated To Doctor At:</strong>
                  <div className='text-muted'>
                    {device.allocated_at ? formatUTCToUserDate(device.allocated_at) : 'N/A'}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' className='text-white' onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default DeviceDetailsModal
